import { UploadedFile } from '../../hooks/file-uploads/types';

export const isDescendantOfFolder = (
  itemId: string,
  targetFolderId: string,
  allFiles: UploadedFile[],
): boolean => {
  if (itemId === targetFolderId) {
    return true;
  }

  const targetFolder = allFiles.find(file => file.id === targetFolderId);
  if (!targetFolder || !targetFolder.isFolder) {
    return false;
  }

  // The `seen` set keeps a broken or cyclic `parentId` chain from looping forever.
  const seen = new Set<string>([targetFolderId]);
  let currentParentId = targetFolder.parentId;

  while (currentParentId && !seen.has(currentParentId)) {
    if (currentParentId === itemId) {
      return true;
    }

    seen.add(currentParentId);
    const parentFolder = allFiles.find(file => file.id === currentParentId);
    currentParentId = parentFolder?.parentId;
  }

  return false;
};
